module.exports = __webpack_public_path__ + "static/media/400395_01.75625e09.png";